import $ from 'jquery';

//
// All Web App variables
//
const SITE_BODY = 'lk-site-body';

// Header
const SITE_HEADER = 'lk-site-header';
const COMPACT_CLASS = 'has-compact-header';

// Navigation
const SITE_NAVIGATION = 'lk-site-navigation';
const SITE_NAVIGATION_BUTTON = 'lk-site-navigation-button';
const OPEN_CLASS = 'has-open-navigation';

const getElement = (className) => {
  return $('.' + className);
};

export {
  getElement,
  SITE_BODY,
  SITE_HEADER,
  COMPACT_CLASS,
  SITE_NAVIGATION,
  SITE_NAVIGATION_BUTTON,
  OPEN_CLASS
}
